import React, { Component } from 'react';
import { Player, PlayProgressBar } from 'video-react';
import ScrollAnimation from 'react-animate-on-scroll';
import 'animate.css/animate.min.css';
import IntlMessages from '../../util/IntlMessages';

class MadeInBotswana extends Component {
  render() {
    return (
      <div>
        <div className="cl-hero--homepage">
          <ScrollAnimation animateIn="slideInDown" animateOut="slideOutUp">
            <div className="TopImageBlock">
              <div className="topImageBox">
                <img src={require('../../assets/img/download.jpg')} alt="" />
              </div>
              <div className="topBlockContent">
                <h2>
                  <IntlMessages id="app.madeinbotswana" />
                </h2>
                <p>
                  P N Shah Diamonds has taken an initiative to support the development of Botswana by investing in its
                  economy & its people. We are working towards empowering local artisans by a transfer of skill sets.
                </p>
                {/* <p>Your diamond has been through the hands of several skilled artisans, each as unique as the diamonds they conscientiously hand craft. We are proud to share their stories with you, and show you how many lives you add a sparkle to when you buy your diamond.</p> */}
              </div>
            </div>
          </ScrollAnimation>
          <ScrollAnimation animateIn="pulse" animateOut="pulse">
            <div className="cl-wrapper">
              <figure className="cl-hero__media">
                <div className="cl-hero__video">
                  <Player muted loop autoPlay={true} src={require('../../assets/img/madeinbotswana/video1.mp4')} />
                </div>
                <a
                  href="javascript:;"
                  className="play-btn cl-hero__play-btn"
                  data-videoid="aNur6UM3UiA"
                  data-video-context="modal"
                  data-modal="videoModal"
                ></a>
              </figure>
              <div className="cl-hero__contents">
                <div className="clContentBox">
                  <div className="userImageArties">
                    <img src={require('../../assets/img/madeinbotswana/arties1.jpg')} alt="" />
                  </div>
                  <div className="clContentRight">
                    <h1 className="cl-hero__title">GLORIA MAIPELO POLISHER</h1>
                    <p>
                      Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been
                      the industry's standard dummy text ever since the 1500s, when an unknown printer took.
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </ScrollAnimation>
          <ScrollAnimation animateIn="pulse">
            <div className="cl-wrapper">
              <figure className="cl-hero__media">
                <div className="cl-hero__video">
                  <Player
                    muted
                    loop
                    autoPlay={true}
                    poster="/assets/poster.png"
                    src={require('../../assets/img/madeinbotswana/video2.mp4')}
                  />
                </div>
                <a
                  href="javascript:;"
                  className="play-btn cl-hero__play-btn"
                  data-videoid="aNur6UM3UiA"
                  data-video-context="modal"
                  data-modal="videoModal"
                ></a>
              </figure>
              <div className="cl-hero__contents">
                <div className="clContentBox">
                  <div className="userImageArties">
                    <img src={require('../../assets/img/madeinbotswana/arties2.jpg')} alt="" />
                  </div>
                  <div className="clContentRight">
                    <h1 className="cl-hero__title">TSAMAISO JACKLAS POLISHER</h1>
                    <p>
                      Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been
                      the industry's{' '}
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </ScrollAnimation>
          <ScrollAnimation animateIn="pulse">
            <div className="cl-wrapper">
              <figure className="cl-hero__media">
                <div className="cl-hero__video">
                  <Player
                    muted
                    loop
                    autoPlay={true}
                    poster="/assets/poster.png"
                    src={require('../../assets/img/madeinbotswana/video3.mp4')}
                  />
                </div>
                <a
                  href="javascript:;"
                  className="play-btn cl-hero__play-btn"
                  data-videoid="aNur6UM3UiA"
                  data-video-context="modal"
                  data-modal="videoModal"
                ></a>
              </figure>
              <div className="cl-hero__contents">
                <div className="clContentBox">
                  <div className="userImageArties">
                    <img src={require('../../assets/img/madeinbotswana/arties3.jpg')} alt="" />
                  </div>
                  <div className="clContentRight">
                    <h1 className="cl-hero__title">LESEGO TLHOWEPOLISHER</h1>
                    <p>
                      Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been
                      the industry's standard dummy text ever since the 1500s, when an unknown printer took.
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </ScrollAnimation>
        </div>
      </div>
    );
  }
}

export default MadeInBotswana;
